import api from "../services/api";

export const listCustomFields = (params = {}) =>
  api.get("/api/contact-custom-fields", { params });
export const createCustomField = (payload) => api.post("/api/contact-custom-fields", payload);
export const updateCustomField = (id, payload) =>
  api.put(`/api/contact-custom-fields/${id}`, payload);
export const archiveCustomField = (id) => api.delete(`/api/contact-custom-fields/${id}`);
